import { SuiteNumber } from "@ssc-booking/api-contracts"
import * as Occupancy from "@ssc-booking/api-contracts/src/occupancy"
import { assign, raise } from "xstate"
import { ECommerceContext } from "../e-commerce-machine-context"
import { ECommerceEvent } from "../e-commerce-machine"

type Context = ECommerceContext
type Events = ECommerceEvent

export const raiseSuiteNumberSelected = (suiteNumber: SuiteNumber) => [
    assign<Context, Events>({ selectedSuiteNumber: suiteNumber }),
    raise<Context, Events, Events>({
        type: "SUITE_NUMBER_SELECTED",
        suiteNumber: suiteNumber,
    }),
]

export const raiseStandardSuiteCategorySelected = (suiteCategory: string, isAutomaticSelection: boolean = false) => [
    assign<Context, Events>({
        selectedSuiteCategory: suiteCategory,
        selectedSuiteCategorySource: "standard",
        isAutomaticSelection,
    }),
    raise<Context, Events, Events>({
        type: "SUITE_CATEGORY_SELECTED",
        suiteCategory: suiteCategory,
    }),
]

export const raiseGuestsChanged = (guests: Occupancy.Occupancy) => [
    assign<Context, Events>({ guests }),
    raise<Context, Events, Events>({ type: "GUESTS_CHANGED", guests }),
]

export const raiseFlightSelected = (flightNumber: string) => [
    assign<Context, Events>({ selectedFlightNumber: flightNumber }),
    raise<Context, Events, Events>({
        type: "FLIGHT_SELECTED",
        flightNumber: flightNumber,
    }),
]
